/* ===== Fadewell cart-drawer upsell swap =====
 * Ported from Pause & Connect's pc-cart-upsell.js and adapted to this theme's
 * native event system (same pattern as fadewell-cart.js).
 *
 * Delegated handler for .fw-upsell__btn (rendered by snippets/fadewell-upsell.liquid
 * inside the drawer's SRA morph region — which is exactly why this file is loaded
 * globally by cart-drawer.liquid, OUTSIDE that region, and uses event delegation:
 * it survives every drawer morph).
 *
 * One atomic POST /cart/update.js swaps the One Tube line for the 60-Day Supply
 * (P&C did add.js + change.js; update.js does both in one request). Follows the
 * house persist-before-redirect rule from fadewell-cart.js: read the cart back and
 * resolve the CartLinesUpdateEvent BEFORE navigating to /checkout.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

if (!window.__fwUpsellInit) {
  window.__fwUpsellInit = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest?.('.fw-upsell__btn');
    if (!btn) return;
    const card = btn.closest('.fw-upsell');
    if (!card || card.dataset.busy === '1') return;

    card.dataset.busy = '1';
    const original = btn.textContent;
    btn.textContent = 'Upgrading…';

    const addVid = card.dataset.addVid;
    const removeVid = card.dataset.removeVid;

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);

    const deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'cart-drawer',
        lines: [{ merchandiseId: String(addVid), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    try {
      const updates = {};
      updates[addVid] = 1;
      updates[removeVid] = 0;

      // 1) atomic swap
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        throw new Error(data.description || data.message || 'Upgrade failed');
      }

      // 2) read-after-write — the persist guarantee before any navigation
      const ajaxCart = await (
        await fetch('/cart.js', { headers: { Accept: 'application/json' } })
      ).json();

      // 3) refresh the in-page cart UI (drawer + icon) from real server state
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: {
          sections: data.sections,
          items: ajaxCart.items,
          itemCount: ajaxCart.item_count,
          source: 'fadewell-upsell',
          didError: false,
        },
      });

      // 4) upgraded — straight to checkout (P&C merchant-choice flow)
      window.location.href = '/checkout';
    } catch (err) {
      deferred.reject(err);
      card.dataset.busy = '0';
      btn.textContent = original;
      console.error('[fadewell-upsell]', err);
    }
  });
}
